import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import AddressDropdown from './AddressDropdown';
import Contact from './Contact';
import { ContactType, ShippingInfo, contactTypes } from './types';
import DeliveryOptionsDropdown from './DeliveryOptionsDropdown';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

interface Props {
  data: Record<string, any>;
  businessInfo: Record<string, any>;
  onChange: (field: string, value: any) => void;
  errors: { [key: string]: string };
  handleSetFullAddress: (fullAddress: {
    address: string;
    address2: string;
    city: string;
    state: string;
    zip: string;
  }) => void;
}
const ShippingInformation = (props: Props) => {
  const baseShippingInfo = {
    address: '',
    city: '',
    state: '',
    zip: '',
    deliveryOption: { id: 0, name: '' },
    contact: {
      firstName: '',
      lastName: '',
      phone: '',
      ext: '',
      email: '',
      preferredMethod: 'phone',
      contactType: contactTypes.Shipping.type,
      sameAsPrimary: false,
    } as ContactType,
  };

  const [shippingInfo, setShippingInfo] =
    useState<ShippingInfo>(baseShippingInfo);

  const handleSameAsBusinessChange = (checked: boolean) => {
    props.onChange('sameAsBusiness', checked);

    if (checked) {
      setShippingInfo((prev) => ({
        ...prev,
        address: props.businessInfo?.address ?? null,
        city: props.businessInfo?.city ?? null,
        state: props.businessInfo?.state ?? { value: 0, label: '' },
        zip: props.businessInfo?.zip ?? null,
      }));
    } else {
      setShippingInfo(baseShippingInfo);
    }
  };

  return (
    <Box
      sx={{
        padding: '20px',
      }}
    >
      <Stack
        width={{ xs: '100%', sm: '90%', md: '80%', lg: '60%' }}
        maxWidth='800px'
        minWidth='200px'
        position={'relative'}
      >
        <Typography style={{ color: '#808080', fontSize: 28 }}>
          Shipping Information
        </Typography>
        <Tooltip
          title='If your facility has designated staff to handle shipping please fill out the fields below'
          sx={{ position: 'absolute', top: 4, left: 280 }}
        >
          <IconButton size='small'>
            <InfoOutlinedIcon fontSize='small' />
          </IconButton>
        </Tooltip>
        <FormGroup sx={{ marginTop: 2 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={props.data.sameAsBusiness}
                onChange={(e) => handleSameAsBusinessChange(e.target.checked)}
                value='yes'
                name='yes'
                color='info'
              />
            }
            label='Same as Business Info'
          />
        </FormGroup>

        <Stack>
          {!props.data.sameAsBusiness && (
            <AddressDropdown
              setAddress1={(value: any) => props.onChange('address', value)}
              setFullAddress={props.handleSetFullAddress}
              inputValue={props.data?.address || ''}
              data={props.data}
              errors={props.errors}
              errorKey='shippingAddress'
              onChange={props.onChange}
              errorCityKey='shippingCity'
              errorStateKey='shippingState'
              errorZipKey='shippingZip'
            />
          )}
          <DeliveryOptionsDropdown
            errors={props.errors}
            onChange={props.onChange}
            data={props.data}
          />
        </Stack>

        <Typography style={{ color: '#808080', fontSize: 22, marginTop: 50 }}>
          Shipping Contact Information
        </Typography>
        <Contact
          contact={props.data.contact}
          handleChange={props.onChange}
          errors={props.errors}
          errorKey='shippingContact'
        />
      </Stack>
    </Box>
  );
};

export default ShippingInformation;
